import { SpacingOptions } from '@mui/system/createTheme/createSpacing'

export const appBarHeightNumber = 48
export const appBarHeight = `${appBarHeightNumber}px`
export const sidebarWidth = '210px'
export const browseSidebarWidth = '304px'
export const sidebarCollapsedWidth = '50px'
export const contentFullHeight = `calc(100vh - ${appBarHeight})`

export const spacing = {
    zero: '0',
    xs: '0.3rem', //  16px * 0.3 = 4.8px
    s: '0.65rem', //  16px * 0.65 = 10.4px
    m: '0.9rem', //   16px * 0.9 = 14.4px
    l: '1.1rem', //   16px * 1.1 = 17.6px
    xl: '2rem', //    16px * 2 = 32px
    xxl: '4rem', //   16px * 4 = 64px
}

const spacingValues = Object.values(spacing)

export const C1Spacing: SpacingOptions = (factor: number): string => {
    if (Number.isInteger(factor) && factor >= 0 && factor < spacingValues.length) {
        return spacingValues[factor]
    }
    // Fallback for non-integer or out-of-range values: 8px base unit
    return `${factor * 8}px`
}
